import Typography from "@mui/material/Typography";

const FooterLogo = ({ previewAgent, renderInputLabelColor }: any) => {
  return (
    <Typography
      sx={{
        fontSize: previewAgent ? 12 : 10,
        textAlign: "center",
        width: "100%",
        color: "#c1c1c1;",
        marginTop: "auto",
        opacity: 0.7,
      }}
    >
      <span
        style={{
          color: renderInputLabelColor(),
        }}
      >
        Powered by
      </span>{" "}
      <b>
        <span
          style={{
            color: renderInputLabelColor(),
          }}
        >
          Cuvo
        </span>
      </b>{" "}
    </Typography>
  );
};

export default FooterLogo;
